import { sharedConfig, SessionStorage } from '@witkac/kartamiejska-shared';

import { config } from '@/utils/config';
import { notificationsMixin } from '@/mixins/notifications';

/**
 * Mixin uploadu
 *
 */
export const uploadMixin = {
  mixins: [notificationsMixin],
  props: {
    schema: { type: Object, required: true }
  },
  data() {
    return {
      mediaURL: config.mediaURL,
      queryString: sharedConfig.sizes.gallery.big.queryString
    };
  },
  computed: {
    uploadHeaders() {
      if (typeof localStorage === 'undefined') {
        return {};
      }

      const token = localStorage.getItem(SessionStorage.TOKEN);
      return token
        ? {
            Authorization: `Bearer ${token}`
          }
        : {};
    }
  },
  methods: {
    handleError(error: any) {
      (this as any).notifyError(error);
    }
  }
};
